import Index from './Index';
import SalesReserve from './SalesReserve';
import {
  Switch,
  Route,
  useRouteMatch,
} from "react-router-dom";

let Combos = (props) => {
  let { path } = useRouteMatch();
  const theme = props.theme;

  return <>
    <Switch>
      <Route exact path={`${path}`}>
        <Index theme={theme} setShowMenu={props.setShowMenu} />
      </Route>
      <Route exact path={`${path}/:type/:id/reservas`}>
        <SalesReserve theme={theme}/>
      </Route>
    </Switch>
  </>
}

export default Combos;
